import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-column justify-content-center p-1 gap-5 container" }
const _hoisted_2 = { class: "col-12 d-flex justify-content-between align-items-center p-0" }
const _hoisted_3 = { class: "d-flex gap-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "m-0 fas fa-arrow-left" }, null, -1)
const _hoisted_5 = {
  key: 0,
  style: {"font-size":"medium","height":"18px","width":"18px"},
  class: "spinner-border",
  role: "status"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  width: "20",
  height: "20",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("path", { d: "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V173.3c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32H64zm0 96c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM224 416c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64z" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "row m-0 card col-12 mb-5" }
const _hoisted_12 = { class: "d-flex align-items-center justify-content-between p-5" }
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex gap-4 align-items-center\"><div><svg width=\"43\" height=\"45\" viewBox=\"0 0 43 45\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect width=\"42.4652\" height=\"45\" rx=\"10\" fill=\"#F9F9F9\"></rect><path d=\"M31.0836 25.2036L29.2696 24.0877C29.4527 23.0353 29.4527 21.9556 29.2696 20.9032L31.0836 19.7873C31.2923 19.6603 31.386 19.3972 31.3178 19.1522C30.8452 17.5373 30.0404 16.0766 28.9886 14.8609C28.8268 14.6749 28.5628 14.6296 28.3584 14.7566L26.5444 15.8725C25.7822 15.1739 24.905 14.6341 23.9555 14.2803V12.053C23.9555 11.7989 23.7894 11.5767 23.5552 11.5222C21.9924 11.1502 20.3914 11.1684 18.9053 11.5222C18.6711 11.5767 18.505 11.7989 18.505 12.053V14.2848C17.5597 14.6432 16.6825 15.183 15.9161 15.877L14.1063 14.7611C13.8977 14.6341 13.6379 14.6749 13.4761 14.8655C12.4244 16.0766 11.6196 17.5373 11.1469 19.1568C11.0745 19.4017 11.1725 19.6648 11.3811 19.7918L13.1951 20.9078C13.012 21.9602 13.012 23.0398 13.1951 24.0922L11.3811 25.2082C11.1725 25.3352 11.0788 25.5983 11.1469 25.8432C11.6196 27.4581 12.4244 28.9188 13.4761 30.1345C13.6379 30.3205 13.9019 30.3659 14.1063 30.2389L15.9203 29.123C16.6825 29.8215 17.5597 30.3614 18.5093 30.7152V32.947C18.5093 33.2011 18.6753 33.4233 18.9095 33.4778C20.4723 33.8498 22.0734 33.8316 23.5595 33.4778C23.7936 33.4233 23.9597 33.2011 23.9597 32.947V30.7152C24.905 30.3568 25.7822 29.817 26.5487 29.123L28.3627 30.2389C28.5713 30.3659 28.8311 30.3251 28.9929 30.1345C30.0446 28.9234 30.8494 27.4627 31.3221 25.8432C31.386 25.5937 31.2923 25.3306 31.0836 25.2036ZM21.2302 26.1245C19.3524 26.1245 17.8237 24.496 17.8237 22.4955C17.8237 20.495 19.3524 18.8664 21.2302 18.8664C23.1081 18.8664 24.6368 20.495 24.6368 22.4955C24.6368 24.496 23.1081 26.1245 21.2302 26.1245Z\" fill=\"#203972\"></path></svg></div><div><p class=\"m-0 subtitulo cor_texto_1\">Config. Projeto</p></div></div>", 1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "px-5" }, [
  /*#__PURE__*/_createElementVNode("hr", { class: "text-muted m-0" })
], -1)
const _hoisted_15 = { class: "d-flex flex-column gap-4 p-5 mb-0" }
const _hoisted_16 = {
  class: "d-flex gap-3",
  style: {"flex-wrap":"wrap"}
}
const _hoisted_17 = { class: "d-flex flex-column gap-1 col-sm" }
const _hoisted_18 = { class: "d-flex gap-1" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "fs-6 d-flex flex-row gap-3 texto" }, " Nome ", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", {
  style: {"color":"red"},
  class: "fs-6 d-flex flex-row gap-3 texto"
}, "*", -1)
const _hoisted_21 = {
  key: 0,
  style: {"color":"red"},
  class: "fs-9"
}
const _hoisted_22 = { class: "d-flex flex-column gap-1 col-sm" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "fs-6 d-flex flex-row gap-3 texto" }, " Descrição ", -1)
const _hoisted_24 = { class: "d-flex flex-column gap-1 col-sm" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "fs-6 d-flex flex-row gap-3 texto" }, " Url ", -1)
const _hoisted_26 = {
  class: "d-flex gap-3",
  style: {"flex-wrap":"wrap"}
}
const _hoisted_27 = { class: "d-flex flex-column gap-1 col-sm" }
const _hoisted_28 = { class: "d-flex gap-1" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "fs-6 d-flex flex-row gap-3 texto" }, " Status ", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", {
  style: {"color":"red"},
  class: "fs-6 d-flex flex-row gap-3 texto"
}, "*", -1)
const _hoisted_31 = {
  key: 0,
  style: {"color":"red"},
  class: "fs-9"
}
const _hoisted_32 = { class: "d-flex flex-column gap-1 col-sm" }
const _hoisted_33 = { class: "d-flex gap-1" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "fs-6 d-flex flex-row gap-3 texto" }, " Categoria ", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", {
  style: {"color":"red"},
  class: "fs-6 d-flex flex-row gap-3 texto"
}, "*", -1)
const _hoisted_36 = {
  key: 0,
  style: {"color":"red"},
  class: "fs-9"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_Button = _resolveComponent("Button")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Title, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.hasIdProject ? 'Editando projeto: '+ _ctx.project.name : 'Criar novo projeto'), 1)
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Button, {
          text: "Voltar",
          type: "button",
          onClick: _cache[0] || (_cache[0] = () => _ctx.router.back())
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_Button, {
          variant: "secondary",
          text: "Salvar",
          disabled: _ctx.loadSave,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.createProject()))
        }, {
          default: _withCtx(() => [
            (_ctx.loadSave)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
              : (_openBlock(), _createElementBlock("svg", _hoisted_8, _hoisted_10))
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("div", null, [
          _createVNode(_component_el_switch, {
            modelValue: _ctx.project.is_active,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.project.is_active) = $event)),
            "active-value": 1,
            "inactive-value": 0
          }, null, 8, ["modelValue"])
        ])
      ]),
      _hoisted_14,
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _hoisted_20,
              (_ctx.fieldRequired && !_ctx.project.name)
                ? (_openBlock(), _createElementBlock("span", _hoisted_21, "Este campo é obrigatório"))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_el_input, {
              modelValue: _ctx.project.name,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.project.name) = $event)),
              placeholder: "Insira o nome"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createVNode(_component_el_input, {
              modelValue: _ctx.project.description,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.project.description) = $event)),
              placeholder: "Insira a descrição"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createVNode(_component_el_input, {
              modelValue: _ctx.project.url,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.project.url) = $event)),
              placeholder: "Insira a url"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _hoisted_29,
              _hoisted_30,
              (_ctx.fieldRequired && _ctx.status.length === 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_31, "Este campo é obrigatório"))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_el_select, {
              modelValue: _ctx.status,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.status) = $event)),
              multiple: "",
              filterable: "",
              "allow-create": "",
              "default-first-option": "",
              "reserve-keyword": false,
              placeholder: "Escolha ou crie status para seu projeto"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusOptions, (item, key) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: key,
                    label: item.name,
                    value: item.name
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _hoisted_34,
              _hoisted_35,
              (_ctx.fieldRequired && _ctx.category.length === 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_36, "Este campo é obrigatório"))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_el_select, {
              id: "teste-select",
              modelValue: _ctx.category,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.category) = $event)),
              multiple: "",
              filterable: "",
              "allow-create": "",
              "default-first-option": "",
              "reserve-keyword": false,
              placeholder: "Escolha ou crie categoria para seu projeto"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryOptions, (item, key) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: key,
                    label: item.name,
                    value: item.name
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ])
      ])
    ])
  ]))
}